exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuwidth {\n    width: 14%;\n}\n\na.menu {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    color: #707070;\n    text-decoration: none;\n}\n\na.firms {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 15px;\n    color: black;\n    font-weight: bold;\n    text-decoration: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-menu/firm-menu.component.css
// module id = ../../../../../src/app/firm-menu/firm-menu.component.css
// module chunks = main